// 飞行记录
export default {
    flyrecirdusermanage: 'Flight Record',
    Flighttime: 'Flying Period',
    starttime: 'Start Date',
    to: 'to',
    endtime: 'date closed',
    taketime: 'Take-off Time',
    landtime: 'Landing Time',
    Durflytime: 'Flying Time',
    total: 'Total',
    records: 'records',
    totaltime: 'Total time',
    errmes: 'Error info',
    surefly: "Ready to take off",
    dspeed: 'Multi-speed',
    flymode: 'Flight mode',
    nextroute: 'Next waypoint',
    nowposition: 'Current position',
    pitch: 'Pitch',
    rool: 'Roll',
    high: 'Height',
    speed: 'Speed',
    play: 'Play',
    total2: 'Total',
    collection: 'Collection',
    remarks: 'Remarks',
    VP: 'Voltage/Power',
    flyingHeight: 'Flying height',
    positioningStatus: 'Positioning status',
    NS: 'Number of satellites',
    rtk: 'RTK',
    voltage: 'Voltage',
    power: 'Power',
    time: 'Time',
}